import moment from "moment/moment";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const getBudgetDetailsAccumulatedCostQuarterlyDateOptions = (
  startDate?: string,
  quarterStartMonth?: number,
) => {
  if (!quarterStartMonth) {
    return [];
  }

  const dateOptions = [];
  const now = moment();

  const currentDate = moment(startDate);
  const currentMonth = currentDate.month() + 1;
  const { start: quarterStart } = getFQuarterByStartMonth(
    currentMonth + 1,
    quarterStartMonth,
  );

  currentDate.set({
    year: currentDate.year(),
    month: moment(quarterStart).month(),
    date: 1,
  });

  while (currentDate.isSameOrBefore(now, "quarter")) {
    const currentMonth = currentDate.month() + 1;
    const { quarter } = getFQuarterByStartMonth(
      currentMonth + 1,
      quarterStartMonth,
    );

    const isCurrentQuarter = currentDate.isSame(now, "quarter");

    dateOptions.push({
      value: formatDate(currentDate, { type: "yearMonthDay" }),
      title: `Q${quarter} ${currentDate.year()}${isCurrentQuarter ? " (QTD)" : ""}`,
    });

    currentDate.add(3, "month");
  }

  return dateOptions;
};
